import produce from 'immer'
import { ThemeAction } from '../actions/themeActions'
import { dark, light } from '../themes'
import { ThemeActionType } from '../action-types'

interface ThemeState {
    selected: 'light' | 'dark'
    theme: {
        primary: string
        black: string
        blackest: string
        blue900: string
        blue400: string
        blue: string
        lightBlue: string
        white: string
        grey: string
        grey300: string
        grey200: string
        grey100: string
        lineGrey: string
        darkColor: string
        secondaryDark: string
        platformGrey: string
        green: string
        red: string
        pink: string
        orange: string
        yellow: string
        greyText: string
        memberColor: string
        lightGrey: string
        lighterGrey: string
    }
}

const initialState: ThemeState = {
    selected: 'light',
    theme: light,
}

const reducer = produce(
    (state: ThemeState = initialState, action: ThemeAction) => {
        switch (action.type) {
            case ThemeActionType.SWITCH_THEME:
                if (state.selected === 'light') {
                    state.selected = 'dark'
                    state.theme = dark
                } else {
                    state.selected = 'light'
                    state.theme = light
                }
                return state
            default:
                return state
        }
    }
)

export default reducer
